export default "__VITE_ASSET__Betr$l1H__"